import { render, staticRenderFns } from "./PesquisarPedido.vue?vue&type=template&id=4a1fd932&scoped=true"
import script from "./PesquisarPedido.vue?vue&type=script&lang=js"
export * from "./PesquisarPedido.vue?vue&type=script&lang=js"
import style0 from "./PesquisarPedido.vue?vue&type=style&index=0&id=4a1fd932&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a1fd932",
  null
  
)

export default component.exports